import { ILayerOriginInfo, ILayerProps } from '@/version-types';

/** 光标提示类型 */
export type ICursorTipType = 'hide' | 'resize' | 'move' | 'rotate' | 'scale' | 'custom';

/** 光标提示参数 */
export type ICursorTipArgs = {
    /** 光标提示类型 */
    type: ICursorTipType;
    /** 左上角x */
    x: number;
    /** 左上角y */
    y: number;
    /** left */
    left?: number;
    /** top */
    top?: number;
    /** 旋转角度 */
    rotate?: number;
    /** 宽度 */
    width?: number;
    /** 高度 */
    height?: number;
    /** 是否最小值 */
    isMin?: boolean;
    /** 自定义文本 */
    txt?: string;
    /** 是否隐藏角标 */
    hideCorner?: boolean;
};

/** 图层hover扩展类型 */
export enum HoverExtendType {
    TEXT_BRUSH = 'text-brush',
    IMAGE_BRUSH = 'image-brush',
}
/** 图层hover扩展参数 */
export type IHoverExtendArgs = {
    /** 图层id */
    layerId: string;
    /** 光标样式，定义在 cursor-kit 中 */
    cursor?: string;
    /** 扩展类型 */
    type: HoverExtendType;
    /** 点击确认 */
    apply: (layerId: string) => void;
    /** 光标提示 */
    cursorTip?: string;
};

/** 全局遮罩参数 */
export type IGlobalMask = {
    /** 是否显示加载中icon */
    loading?: boolean;
    /** 加载中文字 */
    text?: string;
    /** 是否显示背景遮罩 */
    background?: boolean | string;
};

/** 删除数据 */
export interface IDelLayerData {
    item: {
        /** 新图层 */
        newLayer?: ILayerProps;
        /** 旧图层 */
        oldLayer: ILayerProps;
        /** 旧图层索引 */
        oldLayerIndex: number;
        /** 替换的图层id */
        replaceLayerId: string;
        /** 删除的图层id */
        delId: string;
        /** 子图层索引 */
        childIndexes: number[];
        /** 子图层id */
        childIds: string[];
        /** 是否删除所有 */
        delAll: boolean;
    };
    operate: {
        /** 激活图层id */
        activeId: string;
    };
}

export enum MoveListenerLevel {
    /** 最优先的等级, 只可做取值操作, 不可有修改操作 */
    PREPARE_LEVEL = 1000,
    /** 默认等级 */
    DEFAULT_LEVEL = 0,
}

export interface IActiveInfo {
    /** 画布信息 */
    info: ILayerOriginInfo;
    /** 子画布信息 */
    childInfoMap: Map<string, ILayerOriginInfo>;
}
